/* eslint-disable jira/filename-case */
const asyncStatuses = {
	idle: 'idle',
	loading: 'loading',
	loaded: 'loaded',
	failed: 'failed',
} as const;

type Idle = {
	status: typeof asyncStatuses.idle;
};

type Loading = {
	status: typeof asyncStatuses.loading;
};

type Loaded<T> = {
	status: typeof asyncStatuses.loaded;
	value: T;
};

type Failed = {
	status: typeof asyncStatuses.failed;
	error: Error;
};

export type AsyncValue<T> = Idle | Loading | Loaded<T> | Failed;

export const asyncValues = {
	idle: (): {
		status: 'idle';
	} => ({
		status: asyncStatuses.idle,
	}),
	loading: (): {
		status: 'loading';
	} => ({
		status: asyncStatuses.loading,
	}),
	loaded: <T,>(
		value: T,
	): {
		status: 'loaded';
		value: T;
	} => ({
		status: asyncStatuses.loaded,
		value,
	}),
	failed: (
		error: Error,
	): {
		status: 'failed';
		error: Error;
	} => ({
		status: asyncStatuses.failed,
		error,
	}),
} as const;
